import {
  CloseOutlined,
  DownloadOutlined,
  SettingOutlined,
} from '@ant-design/icons'
import { Button, Card, Form, Input, Modal, Typography } from 'antd'
import { useCallback, useEffect, useState } from 'react'
import {
  createFeegowIntegration,
  deleteFeegowIntegration,
  getFeegowIntegration,
  updateFeegowIntegration,
} from '../../services/feegow-integration'

import { toast } from 'sonner'
export function FeegowIntegration({ icon, label, assistantID }) {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState()
  const [buttonLoading, setButtonLoading] = useState(false)
  const [configOpen, setConfigOpen] = useState(false)
  const [form] = Form.useForm()

  useEffect(() => {
    setLoading(true)
    getFeegowIntegration({ assistantID })
      .then(({ data }) => {
        if (data.length === 0) return
        setData(data[0])
      })
      .catch((error) => {
        console.log(error)
        toast.error('Erro ao buscar integração com Feegow.')
      })
      .finally(() => {
        setLoading(false)
      })
  }, [assistantID])

  const install = useCallback(
    (values) => {
      setButtonLoading(true)
      createFeegowIntegration({
        assistantID: parseInt(assistantID),
        active: true,
        ...values,
      })
        .then(({ data }) => {
          setData(data)
          setConfigOpen(false)
        })
        .catch((error) => {
          console.log(error)
          toast.error('Erro ao instalar integração com Feegow.')
        })
        .finally(() => {
          setButtonLoading(false)
          form.resetFields()
        })
    },
    [assistantID]
  )

  const uninstall = useCallback(() => {
    setButtonLoading(true)
    deleteFeegowIntegration(data.id)
      .then(() => {
        setData(undefined)
      })
      .catch((error) => {
        console.log(error)
        toast.error('Erro ao remover integração com Feegow.')
      })
      .finally(() => {
        setButtonLoading(false)
      })
  }, [data])

  const update = useCallback(
    (newData) => {
      setButtonLoading(true)
      updateFeegowIntegration(data.id, { ...data, ...newData })
        .then(({ data: updatedData }) => {
          setData({ ...updatedData })
          setConfigOpen(false)
          toast.success('Atualizado com sucesso!')
        })
        .catch((error) => {
          console.log(error)
          toast.error('Erro ao atualizar.')
        })
        .finally(() => {
          setButtonLoading(false)
          form.resetFields()
        })
    },
    [data]
  )

  const finishForm = useCallback(
    (values) => {
      const payload = { ...values }
      
      if (!data) return install(payload)
      update(payload)
    },
    [data, install, update]
  )

  useEffect(() => {
    form.setFieldsValue(data)
  }, [data, form])

  return (
    <>
      <Modal
        title="Configurar Feegow"
        open={configOpen}
        cancelText={'Cancelar'}
        confirmLoading={buttonLoading}
        okText={'Salvar'}
        onOk={form.submit}
        onCancel={() => setConfigOpen(false)}
      >
        <br />

        <Form layout={'vertical'} form={form} onFinish={finishForm}>
          <Form.Item
            label={'Token'}
            help={
              <>
                Acesse o{' '}
                <Typography.Link
                  href={'https://ajuda.feegow.com/support/solutions/articles/67000714396-como-integrar-o-feegow-via-api-com-outros-sistemas-'}
                  target={'_blank'}
                  rel="noreferrer"
                >
                  tutorial de integração via API
                </Typography.Link>{' '}
                para obter seu token de acesso
              </>
            }
            name={'token'}
          >
            <Input.Password
              placeholder={'Token de acesso do Feegow'}
              autoComplete="off"
            />
          </Form.Item>
        </Form>
      </Modal>
      <Card
        loading={loading}
        title={
          <Typography.Title level={5} ellipsis={{ tooltip: label }}>
            {icon} {label}
          </Typography.Title>
        }
        extra={
          <Button
            type={data ? 'default' : 'primary'}
            loading={loading || buttonLoading}
            danger={!!data}
            onClick={() => (data ? uninstall() : setConfigOpen(true))}
            icon={data ? <CloseOutlined /> : <DownloadOutlined />}
          >
            {loading ? undefined : data ? 'Remover' : 'Instalar'}
          </Button>
        }
        actions={
          data
            ? [<SettingOutlined onClick={() => setConfigOpen(true)} />]
            : undefined
        }
      >
        <Typography>
          Integre com sua clínica no{' '}
          <a target={'_blank'} rel="noreferrer" href={'https://feegow.com'}>
            Feegow
          </a>{' '}
          para gestão de pacientes e agendamentos.
        </Typography>
      </Card>
    </>
  )
}
